<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <div class="prepend-icon"><v-icon>search</v-icon></div>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="filter.keyword"
          />
        </div>
        <button class="btn btn-primary w-88px" @click="getShareholderEvents">搜尋</button>
      </div>

      <!-- table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">活動名稱</th>
            <th class="text-left">時間</th>
            <th class="text-left">地點</th>
            <th class="text-left">編輯</th>
            <th class="text-left">刪除</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in shareholderEvents"
            :key="item.id"
          >
            <td>{{ item.title }}</td>
            <td class="w-140px">{{ stampToDate(item.event_date) }}</td>
            <td>{{ item.address }}</td>
            <td>
              <button class="btn square" @click="editItem(item.id)">
                <v-icon>edit</v-icon>
              </button>
            </td>
            <td>
              <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- table footer -->
      <Pagination @handleNextPreEvent="getShareholderEvents" model="shareholderEvent"></Pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  components: {
    deleteDialog,
    Pagination,
  },
  computed: {
    ...mapState('shareholderEvent', ['shareholderEvents', 'filter']),
  },
  methods: {
    ...mapActions('shareholderEvent', {
      getShareholderEvents: 'find',
      destroyShareholderEvent: 'destroy',
      clear: 'clear',
    }),
    editItem(id) {
      this.$router.push({
        name: 'LatestEventsEdit',
        params: { id },
      });
    },
    async deleteItem(id) {
      this.clear();
      await this.destroyShareholderEvent(id).then(() => {
        this.getShareholderEvents();
      });
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const date = String(dateObj.getDate()).padStart(2, '0');
      return `${year}年${month}月${date}日`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-event-name {
    width: 180px;
    margin-right: 10px;
  }
  .col-time {
    width: 100px;
    margin-right: 40px;
  }
}
</style>
